// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { BatchGetProductsApiParameter } from "@insite/client-framework/Services/ProductService";
import {
    chain,
    ProcessProducts,
    UploadError,
} from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import {
    OrderUploadRowError,
    UploadedItem,
} from "@insite/client-framework/Store/Components/OrderUpload/OrderUploadState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";

export const enum XNGUploadError {
    None,
    NotEnough,
    ConfigurableProduct,
    StyledProduct,
    Unavailable,
    InvalidUnit,
    NotFound,
    OutOfStock,
    Negative,
    MinimumBiggerMaximum,
    Over25Chars,
    Existed,
    BinNegativeCount,
    BinNotFound,
    WrongType,
    MisMatch,
    ProductRequired,
    CountNotProvided,
    // xng-change
    NoUnitOfMeasure,
}
export const xngProcessProducts: typeof ProcessProducts = props => {
    const state = props.getState();
    const currentPage = getCurrentPage(state);
    const processState =
        ["VmiBinsPage", "VmiLocationDetailsPage"].indexOf(currentPage.type) !== -1
            ? state.components.vmiBinsImportModal.modalIsOpen
                ? state.components.vmiBinsImportModal
                : state.components.vmiCountsImportModal
            : state.components.orderUpload;
    const products = props.result.apiResult;

    for (let i = 0; i < products.length; i++) {
        const item =
            "uploadedItems" in processState
                ? processState.uploadedItems[i]
                : "parsedItems" in processState
                ? processState.parsedItems[i]
                : null;
        if (item === null) {
            continue;
        }
        const index = props.parameter.firstRowHeading ? i + 2 : i + 1;
        const product = products[i];
        // we just want to check in case we have a product
        if (product) {
            const isProductErrored = props.result.rowErrors.find(({ index: _index }) => index === _index);
            if (!item?.unitOfMeasure && !isProductErrored) {
                props.result.rowErrors.push({
                    index,
                    error: XNGUploadError.NoUnitOfMeasure as any,
                    name: item.name,
                    qtyRequested: item.qtyOrdered || product.qtyOrdered,
                    umRequested: "-",
                    qtyOnHand: product.qtyOnHand,
                });
                props.result.products = props.result.products.filter(({ id }) => product.id !== id);
            }
        }
    }
};

addToChainAfter(chain, ProcessProducts, xngProcessProducts);
